import { assignSetting, getSettingValueWithoutAssignment } from "@faire/help-center-utils/settings/getSetting";
import { HELP_CENTER_SEARCH_AND_NAV_IMPROVEMENTS_240715 } from "@faire/web-api/indigofair/settings/HELP_CENTER_SEARCH_AND_NAV_IMPROVEMENTS_240715";
export function getSettingHelpCenterSearchAndNavImprovementsWithoutAssignment() {
  return getSettingValueWithoutAssignment(HELP_CENTER_SEARCH_AND_NAV_IMPROVEMENTS_240715, false);
}
export var assignHelpCenterSearchAndNavImprovements = function assignHelpCenterSearchAndNavImprovements() {
  return assignSetting(HELP_CENTER_SEARCH_AND_NAV_IMPROVEMENTS_240715);
};